/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import './CustomerResponse.scss';
import Arrow from 'assets/icons/pink-bubble-arrow.svg';
import ReactSVG from 'react-svg';
import _ from 'lodash';

class CustomerResponse extends Component {
  static propTypes = {
    /** Message to display */
    message: PropTypes.string,
    /** If we translate or not the message */
    toTranslate: PropTypes.bool,
    /** Is RTL */
    rtl: PropTypes.bool,
  }

  static defaultProps = {
    message: 'message from customer',
    toTranslate: true,
    rtl: false,
  }

  render() {
    const {
      message, toTranslate, showMap, rtl, option, intl,
    } = this.props;

    const responseClass = classNames({
      'customer-response--rtl': rtl,
      'customer-response--withMap': showMap,
    });

    const messageClass = classNames({
      'customer-response__message--withAvatar': option && option.icon,
      'customer-response__message--isRoundIcon': option && option.isRoundIcon,
    });
    const parseAdvisor = (text) => {
      switch (text) {
        case 'Deena Yousef Al-Refai':
          return intl.formatMessage({ id: 'deenaAlRefai' });
        case 'Abdullah Anwar Al-Nouri':
          return intl.formatMessage({ id: 'abdullahAlNouri' });
        case 'Abdullatif Waleed Alnusif':
          return intl.formatMessage({ id: 'abdullatifAlnusif' });
        case 'Mohammed F. AlSmaiee':
          return intl.formatMessage({ id: 'mohammedAlsmaiee' });
        case 'Mariam Al Marzouq':
          return intl.formatMessage({ id: 'mariamAlMarzouq' });
        default:
          return text;
      }
    };

    const intlMessage = option.toTranslate === false
      ? <span>{parseAdvisor(message)}</span> : (option.translateOptions && !_.isEmpty(option.translateOptions)
        // eslint-disable-next-line react/no-danger
        ? <FormattedMessage id={message} values={option.translateOptions} /> : <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: message }) }} />);
    return (
      <div className={`customer-response ${responseClass}`}>
        <div className={`customer-response__message ${messageClass}`}>
          {option && option.icon && <div className="customer-response__icon" style={{ backgroundImage: `url(${option.icon})` }} />}
          <div>
            {option && option.prefix && <span>{option.prefix}</span>}
            {toTranslate ? intlMessage : message}
            {option && option.suffix && <span>{intl.formatMessage({ id: option.suffix })}</span>}
          </div>

          <ReactSVG src={Arrow} className="arrow" />
        </div>
      </div>
    );
  }
}

export default injectIntl(CustomerResponse);
